import { Routes } from '@angular/router';
import { authGuard } from '@core/auth/auth.guard';
import { AdminLayout } from '@core/layout/admin/admin';
import { CandidateLayout } from '@core/layout/candidate/candidate';
import { GuestLayout } from '@core/layout/guest/guest';
import { CandidateAnalyzePage } from '@features/candidates/analyze/candidate-analyze-page';
import { CandidatesPage } from '@features/candidates/candidates-page';
import { AllProblemsPage } from '@features/exams/all-problems/all-problems-page';
import { ExamConfirmPage } from '@features/exams/exam-confirm-page';
import { ProblemPage } from '@features/exams/problem/problem-page';
import { CompleteSubmission } from '@features/handle/complete-submission/complete-submission';
import { Forbidden } from '@features/handle/forbidden/forbidden';
import { InvitationsPage } from '@features/invitations/invitations-page';
import { LoginPage } from '@features/login/login-page';
import { CreatePage as ProblemCreatePage } from '@features/problems/create-page/create-page';
import { EditPage as ProblemEditPage } from '@features/problems/edit-page/edit-page';
import { ProblemsPage } from '@features/problems/problems-page';
import { ViewPage as ProblemViewPage } from '@features/problems/view-page/view-page';
import { CreatePage as TestSetCreatePage } from '@features/test-sets/create-page/create-page';
import { EditPage as TestSetEditPage } from '@features/test-sets/edit-page/edit-page';
import { TestSetsPage } from '@features/test-sets/test-sets-page';
import { ViewPage } from '@features/test-sets/view-page/view-page';
import { UsersPage } from '@features/users/users-page';

export const routes: Routes = [
  // Root route - smart redirect based on auth status
  {
    path: '',
    canActivate: [authGuard],
    children: [],
  },

  // Guest routes (public access)
  {
    path: '',
    component: GuestLayout,
    children: [
      {
        path: 'login',
        component: LoginPage,
      },
      {
        path: 'exam',
        component: ExamConfirmPage,
      },
      {
        path: 'exam/complete',
        component: CompleteSubmission,
      },
      {
        path: 'forbidden',
        component: Forbidden,
      },
    ],
  },

  // Candidate routes (for exam taking)
  {
    path: '',
    component: CandidateLayout,
    children: [
      {
        path: 'exam/:testSetId',
        children: [
          {
            path: '',
            component: AllProblemsPage,
          },
          {
            path: 'problem/:problemId',
            component: ProblemPage,
          },
        ],
      },
    ],
  },

  // HR / TL routes (protected)
  {
    path: '',
    component: AdminLayout,
    canActivate: [authGuard],
    children: [
      {
        path: 'invitations',
        component: InvitationsPage,
      },
      {
        path: 'candidates',
        children: [
          {
            path: '',
            component: CandidatesPage,
          },
          {
            path: 'analyze/:candidateId',
            component: CandidateAnalyzePage,
          },
        ],
      },
      {
        path: 'test-sets',
        children: [
          {
            path: '',
            component: TestSetsPage,
          },
          {
            path: 'create',
            component: TestSetCreatePage,
          },
          {
            path: 'edit/:testSetId',
            component: TestSetEditPage,
          },
          {
            path: 'view/:testSetId',
            component: ViewPage,
          },
        ],
      },
      {
        path: 'problems',
        children: [
          {
            path: '',
            component: ProblemsPage,
          },
          {
            path: 'create',
            component: ProblemCreatePage,
          },
          {
            path: 'edit/:problemId',
            component: ProblemEditPage,
          },
          {
            path: 'view/:problemId',
            component: ProblemViewPage,
          },
        ],
      },
      {
        path: 'users',
        component: UsersPage,
      },
    ],
  },

  // Wildcard route - should be last
  {
    path: '**',
    redirectTo: '/forbidden',
  },
];
